import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ConnectionsContractorsDataSource } from '../types'

const getOptions = (): Array<Column<ConnectionsContractorsDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap) as Array<keyof ConnectionsContractorsDataSource>

  return columnsKeys.map(key => {
    const column: Column<ConnectionsContractorsDataSource> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<ConnectionsContractorsDataSource>> => {
  return getColumnsFromMap<ConnectionsContractorsDataSource>({
    columnTitleMap,
    options: [...getOptions()]
  })
}
